var render = function render(){var _vm=this,_c=_vm._self._c;return _c('validation-provider',{attrs:{"name":_vm.label,"rules":"required"},scopedSlots:_vm._u([{key:"default",fn:function({ errors }){return [_c('v-autocomplete',{attrs:{"label":_vm.label,"placeholder":_vm.placeholder,"required":"","return-object":"","items":_vm.items,"item-text":(item) =>
        item.business_name +
        ' - ' +
        `${item.cnpj != null ? item.cnpj : item.cpf}`,"item-value":"public_id","error-messages":errors,"readonly":_vm.readonly,"disabled":_vm.disabled},model:{value:(_vm.intValue),callback:function ($$v) {_vm.intValue=$$v},expression:"intValue"}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }